/**
 * Short physical-tray line after Print now — packing-station language, not an error.
 */

export function countCopiedSheets(physicalSheetsByOrder = {}, copiesByOrder = {}) {
  return Object.entries(physicalSheetsByOrder).reduce((sum, [key, sheets]) => {
    const copies = Math.max(1, Number(copiesByOrder[key]) || 1);
    return sum + Math.max(0, Number(sheets) || 0) * copies;
  }, 0);
}

export function buildPrintBenchLine({
  format = 'standard',
  slipSheetCount = 0,
  separatorSheetCount = 0,
  giftCardCount = 0,
  pickListCount = 0,
} = {}) {
  const tray1 = [];
  if (pickListCount > 0) {
    tray1.push(`${pickListCount} pick list`);
  }
  if (format !== 'cheetah' && slipSheetCount > 0) {
    tray1.push(`${slipSheetCount} A4`);
  }
  if (separatorSheetCount > 0) {
    tray1.push(
      `${separatorSheetCount} separator${separatorSheetCount === 1 ? '' : 's'}`,
    );
  }

  const parts = [];
  if (tray1.length) parts.push(`Tray 1: ${tray1.join(' + ')}`);
  if (format === 'cheetah' && slipSheetCount > 0) {
    parts.push(`Tray 2: ${slipSheetCount} Cheetah`);
  }
  if (format === 'go4') {
    parts.push('GoDEX: outside labels');
  }
  if (giftCardCount > 0) parts.push(`MP: ${giftCardCount} A6`);
  return parts.join(' · ') || 'Job sent to the printer';
}
